import React from 'react'
import Post from './Post'
import { ResBlog } from '~/types/blog'

type PropsPosts = {
    posts: ResBlog[]
}
const Posts = ({ posts }: PropsPosts) => {
    return (
        <section className='grid gap-y-8 sm:grid-cols-2 sm:gap-x-4'>
            {posts.map((blog) => (
                <Post key={blog.id} blog={blog} />
            ))}
        </section>
    )
}

export default Posts
